import EmblaCarousel from "embla-carousel";
import AutoHeight from 'embla-carousel-auto-height';
import Fade from 'embla-carousel-fade';

function init() {
  const track = document.querySelector("[data-panel-viewport]");
  if (!track) return;

  const embla = EmblaCarousel(track, {
    loop: false,
    align: "center",
    draggable: false,
    watchDrag: () => false
  },[AutoHeight(), Fade()]);

  const open_buttons = track.querySelectorAll("[data-panel-target]");
  const back_buttons = track.querySelectorAll("[data-panel-back]");

  open_buttons.forEach((button) => {
    button.addEventListener("click", () => {
      let index = button.getAttribute("data-panel-target");
      if (index == null) return;
      embla.scrollTo(parseInt(index), true);
    });
  });

  back_buttons.forEach((button) => {
    button.addEventListener("click", () => {
      let index = button.getAttribute("data-panel-back");
      if (index == null) return;
      embla.scrollTo(parseInt(index), true);
    });
  });

  const banner_embla = EmblaCarousel(document.querySelector(".menu__banner .embla__viewport"));
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init, { once: true });
} else {
  init();
}
